// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","Address":"Footer_Address__bShfm","Icon":"Footer_Icon__t1Xos"};